import type { Messages } from './en';

export const fr: Messages = {
  "language.label": "Langue",
  "auth.login": "Se connecter",
  "auth.signup": "Créer un compte",
  "auth.signupTitle": "Créez votre compte",
  "auth.signupLead": "Créez votre compte, confirmez votre e-mail, et votre essai gratuit peut démarrer aussitôt.",
  "auth.loginLead": "Connectez-vous avec votre e-mail ou le nom d'utilisateur que nous vous avons envoyé.",
  "auth.passwordChanged": "Mot de passe modifié. Connectez-vous avec votre nouveau mot de passe.",
  "auth.name": "Votre nom",
  "auth.email": "E-mail",
  "auth.emailOrUsername": "E-mail ou nom d'utilisateur",
  "auth.whatsapp": "Numéro WhatsApp",
  "auth.whatsappHint": "Pour pouvoir vous joindre sur WhatsApp.",
  "auth.password": "Mot de passe",
  "auth.keepLoggedIn": "Rester connecté sur cet appareil",
  "auth.wait": "Veuillez patienter…",
  "auth.forgot": "Mot de passe oublié ?",
  "auth.enterName": "Saisissez votre nom.",
  "auth.weakPassword": "Choisissez un mot de passe plus sûr : il doit remplir tous les critères de la liste sous le mot de passe.",
  "auth.deviceUnsupported": "Cet appareil n'est pas pris en charge.",
  "auth.loginAgain": "Reconnectez-vous.",
  "auth.accountDeleted": "Votre compte a été supprimé.",
  "password.rules": "Critères du mot de passe",
  "password.length": "Au moins 8 caractères",
  "password.upper": "Une lettre majuscule",
  "password.lower": "Une lettre minuscule",
  "password.number": "Un chiffre",
  "password.done": "(fait)",
  "password.missing": "(manquant)",
  "phone.country": "Pays : {name}, +{dial}",
  "phone.placeholder": "6 12 34 56 78",
  "phone.search": "Cherchez votre pays",
  "phone.countries": "Pays",
  "phone.noCountry": "Aucun pays trouvé",
  "reset.title": "Réinitialiser votre mot de passe",
  "reset.sent": "Si {email} a un compte, nous lui avons envoyé un code à 6 chiffres. Saisissez-le avec votre nouveau mot de passe.",
  "reset.lead": "Saisissez votre e-mail et nous vous enverrons un code.",
  "reset.code": "Code",
  "reset.newPassword": "Nouveau mot de passe",
  "reset.save": "Enregistrer le mot de passe",
  "reset.send": "Envoyer le code",
  "reset.back": "Retour à la connexion",
  "catalog.title": "Dans quelles langues regardez-vous ?",
  "catalog.lead": "Vos chaînes, films et séries seront dans ces langues, pour que l'application se charge vite sur votre téléphone et votre TV.",
  "catalog.continue": "Continuer",
  "catalog.languages": "Langues",
  "catalog.more": "Plus de langues…",
  "catalog.international": "Aussi les films et séries internationaux",
  "catalog.internationalHint": "(sans langue précise, par ex. « Films Netflix » : la liste devient plus grande)",
  "catalog.note": "Les matchs du jour sur l'Accueil restent disponibles dans toutes les langues. Vous pouvez modifier ce choix à tout moment dans Compte.",
  "catalog.saving": "Enregistrement…",
  "catalog.chooseOne": "Choisissez au moins une langue",
  "verify.title": "Confirmez votre e-mail",
  "verify.lead": "Nous avons envoyé un code à 6 chiffres à {email}. Saisissez-le ci-dessous. Vérifiez vos spams si vous ne le voyez pas.",
  "verify.code": "Code",
  "verify.newCodeSent": "Un nouveau code est en route.",
  "verify.checking": "Vérification…",
  "verify.confirm": "Confirmer",
  "verify.resend": "Envoyer un nouveau code",
  "noAccess.noPlan.title": "Commencez votre essai gratuit",
  "noAccess.noPlan.body": "Demandez votre essai gratuit et regardez tout sur cet appareil. La plupart des essais démarrent aussitôt ; votre temps commence quand vous lancez une première vidéo.",
  "noAccess.noPlan.contact": "Bonjour, je souhaite m'abonner à IPTViva.",
  "noAccess.pending.title": "Essai demandé",
  "noAccess.pending.body": "Nous avons bien reçu votre demande et allons activer votre essai gratuit sous peu. Cet écran ouvre les chaînes dès qu'il est actif.",
  "noAccess.pending.contact": "Bonjour, j'ai demandé un essai gratuit sur IPTViva.",
  "noAccess.used.title": "Essai gratuit déjà utilisé",
  "noAccess.used.body": "Cet appareil, ce numéro ou cet e-mail a déjà eu un essai gratuit. Abonnez-vous pour continuer à regarder.",
  "noAccess.used.contact": "Bonjour, mon essai gratuit est utilisé et je souhaite m'abonner à IPTViva.",
  "noAccess.trialEnded.title": "Votre essai gratuit est terminé",
  "noAccess.trialEnded.body": "Nous espérons qu'il vous a plu. Abonnez-vous pour continuer : Standard pour un écran, Premium pour deux en même temps.",
  "noAccess.trialEnded.contact": "Bonjour, mon essai gratuit est terminé et je souhaite m'abonner à IPTViva.",
  "noAccess.expired.title": "Votre abonnement est terminé",
  "noAccess.expired.body": "Renouvelez votre abonnement pour continuer à regarder.",
  "noAccess.expired.contact": "Bonjour, je souhaite renouveler mon abonnement IPTViva.",
  "noAccess.sending": "Envoi…",
  "noAccess.request": "Demander l'essai gratuit",
  "noAccess.waiting": "En attente d'activation…",
  "noAccess.contactWhatsapp": "Nous contacter sur WhatsApp",
  "noAccess.subscribeWhatsapp": "S'abonner sur WhatsApp",
  "noAccess.loggedInAs": "Connecté en tant que {name}",
  "common.logOut": "Se déconnecter",
  "common.cancel": "Annuler",
  "common.back": "Retour",
  "common.tryAgain": "Réessayer",
  "delete.link": "Supprimer mon compte",
  "delete.title": "Supprimer votre compte ?",
  "delete.body": "Votre compte et ses informations sont supprimés définitivement. Saisissez votre mot de passe pour confirmer.",
  "delete.deleting": "Suppression…",
  "delete.confirm": "Supprimer le compte",
  "unverified.title": "Impossible de vérifier votre accès",
  "unavailable.title": "IPTViva est indisponible",
  "unavailable.device": "Cet appareil n'a pas pu être identifié. Redémarrez l'application et réessayez.",
  "unavailable.build": "Cette version n'a pas de serveur de comptes configuré (VITE_ACCOUNT_API).",
  "error.invalid-credentials": "E-mail, nom d'utilisateur ou mot de passe incorrect.",
  "error.account-disabled": "Ce compte a été désactivé. Contactez-nous.",
  "error.trial-used-on-device": "Cet appareil a déjà eu un essai gratuit. Connectez-vous avec un compte abonné, ou contactez-nous pour vous abonner.",
  "error.trial-bound-to-other-device": "Votre essai gratuit est déjà utilisé sur votre autre appareil. Abonnez-vous pour regarder sur plus d'appareils.",
  "error.device-limit": "Ce compte est déjà utilisé sur tous les appareils autorisés par son offre. Pour l'utiliser sur un nouvel appareil, contactez le support.",
  "error.unsupported-device": "Cet appareil n'est pas pris en charge.",
  "error.rate-limited": "Trop de tentatives. Patientez un moment et réessayez.",
  "error.session-ended": "Vous avez été déconnecté. Reconnectez-vous.",
  "error.invalid-email": "Saisissez une adresse e-mail valide.",
  "error.disposable-email": "Les adresses e-mail temporaires ne sont pas acceptées. Utilisez votre e-mail habituel.",
  "error.invalid-phone": "Saisissez votre numéro WhatsApp avec l'indicatif du pays.",
  "error.weak-password": "Choisissez un mot de passe plus sûr : au moins 8 caractères, avec une majuscule, une minuscule et un chiffre.",
  "error.missing-name": "Saisissez votre nom.",
  "error.email-taken": "Un compte existe déjà avec cet e-mail. Connectez-vous plutôt.",
  "error.wrong-password": "Mot de passe incorrect.",
  "error.invalid-code": "Code incorrect ou expiré. Vérifiez l'e-mail ou demandez un nouveau code.",
  "error.code-too-soon": "Un code vient d'être envoyé. Attendez une minute avant d'en demander un autre.",
  "error.not-active": "Votre compte n'a pas d'offre active.",
  "error.email-unavailable": "La réinitialisation par e-mail n'est pas encore disponible. Contactez-nous sur WhatsApp et nous vous enverrons un nouveau mot de passe.",
  "error.invalid-input": "Choisissez au moins une langue.",
  "error.server-error": "Une erreur s'est produite. Réessayez.",
  "error.offline": "Impossible de joindre le serveur. Vérifiez votre connexion internet.",
  "error.not-configured": "Le serveur de comptes n'est pas configuré dans cette version.",
  "common.close": "Fermer",
  "common.dismiss": "Fermer",
  "common.loading": "Chargement…",
  "nav.main": "Principal",
  "nav.home": "Accueil",
  "nav.live": "TV en direct",
  "nav.movies": "Films",
  "nav.series": "Séries",
  "nav.search": "Recherche",
  "nav.account": "Compte",
  "kind.live": "Direct",
  "kind.movie": "Film",
  "kind.series": "Série",
  "tile.sports": "Sport en direct",
  "tile.movies": "Films",
  "tile.series": "Séries",
  "tile.kids": "Enfants",
  "tile.music": "Musique",
  "tile.news": "Infos",
  "tile.uhd": "4K UHD",
  "tile.docs": "Documentaires",
  "tile.football": "Football",
  "tile.cinema": "Cinéma",
  "tile.cartoons": "Dessins animés",
  "tile.concerts": "Concerts",
  "sync.connecting": "Connexion",
  "sync.downloading": "Téléchargement de la liste",
  "sync.live": "Chargement des chaînes en direct",
  "sync.movie": "Chargement des films",
  "sync.series": "Chargement des séries",
  "sync.saving": "Enregistrement",
  "sync.starting": "Démarrage",
  "sync.items": "{count} éléments",
  "sync.of": "{done} sur {total}",
  "sync.adding": "Chargement de {name}",
  "sync.updating": "Mise à jour de {name}",
  "sync.importing": "Import de {name}",
  "sync.busy": "La liste des chaînes est encore en cours de mise à jour. Attendez la fin.",
  "errors.refused": "Le fournisseur a refusé la demande. Vérifiez que le compte est actif et ne dépasse pas sa limite de connexions.",
  "errors.notFound": "L'adresse est introuvable sur le serveur.",
  "errors.serverProblem": "Le serveur du fournisseur a signalé un problème. Vérifiez qu'aucun autre appareil n'utilise ce compte, attendez une minute et réessayez.",
  "errors.network": "Impossible de joindre le serveur. Vérifiez votre connexion internet.",
  "errors.timeout": "Le serveur a mis trop de temps à répondre. Réessayez plus tard.",
  "errors.http": "Le serveur a renvoyé une erreur.",
  "errors.bad-credentials": "Nom d'utilisateur ou mot de passe incorrect.",
  "errors.account-expired": "Ce compte a expiré. Contactez-nous.",
  "errors.account-disabled": "Ce compte est désactivé. Contactez-nous.",
  "errors.empty-playlist": "La liste ne contient ni chaîne ni vidéo.",
  "errors.parse": "La liste n'a pas pu être lue.",
  "errors.invalid-input": "Des informations manquent ou sont invalides.",
  "errors.storage": "L'enregistrement des données sur cet appareil a échoué. Libérez de l'espace et réessayez.",
  "errors.cancelled": "Annulé.",
  "search.all": "Tout",
  "search.placeholder": "Chaînes, films, séries",
  "search.tooShort": "Saisissez au moins {count} caractères.",
  "search.none": "Aucun résultat",
  "search.results": "{count} résultats",
  "filter.language": "Langue",
  "filter.allLanguages": "Toutes les langues",
  "filter.country": "Pays",
  "filter.allCountries": "Tous les pays",
  "browse.loadingChannels": "Chargement de vos chaînes… Si rien n'apparaît, ouvrez Compte et touchez Charger les chaînes.",
  "browse.source": "Source",
  "browse.categories": "Catégories",
  "browse.other": "Autres",
  "browse.recent": "Ajouts récents",
  "browse.front": "À la une",
  "browse.continue": "Reprendre",
  "browse.seeAll": "Tout voir",
  "browse.previous": "Précédent",
  "browse.next": "Suivant",
  "browse.episodes": "Épisodes",
  "browse.watched": "Regardées récemment",
  "favorites.title": "Favoris",
  "favorites.add": "Ajouter {name} aux favoris",
  "favorites.remove": "Retirer {name} des favoris",
  "series.continue": "Reprendre {episode} à {time}",
  "browse.allFiltered": "Tout {filter}",
  "browse.empty.live": "Il n'y a pas de chaînes en direct ici.",
  "browse.empty.movie": "Il n'y a pas de films ici.",
  "browse.empty.series": "Il n'y a pas de séries ici.",
  "browse.unfinished": "{kind} n'a pas fini de se charger.",
  "browse.load.live": "Charger les chaînes en direct",
  "browse.load.movie": "Charger les films",
  "browse.load.series": "Charger les séries",
  "browse.loading.live": "Chargement des chaînes en direct…",
  "browse.loading.movie": "Chargement des films…",
  "browse.loading.series": "Chargement des séries…",
  "browse.meanwhile": "En attendant, {count} chaînes en direct sont prêtes dans TV en direct.",
  "series.loading": "Chargement des épisodes…",
  "series.seasons": "Saisons",
  "account.username": "Nom d'utilisateur",
  "account.name": "Nom",
  "account.plan": "Offre",
  "account.freeTrial": "Essai gratuit",
  "account.screens": "Écrans en même temps",
  "account.unlimited": "Illimité",
  "account.trialEndsIn": "L'essai se termine dans",
  "account.validUntil": "Valable jusqu'au",
  "account.trialNotStarted": "{length} · démarre quand vous lancez une vidéo",
  "account.noEnd": "Sans date de fin",
  "account.content": "Contenu",
  "account.lastLoad": "Dernier chargement",
  "account.lastLoadDetail": "{total} ({waiting} d'attente du serveur, {download} de téléchargement, {storing} d'enregistrement sur cet appareil)",
  "account.loading.live": "chaînes en cours de chargement…",
  "account.loading.movie": "films en cours de chargement…",
  "account.loading.series": "séries en cours de chargement…",
  "account.count.live": "{count} chaînes",
  "account.count.movie": "{count} films",
  "account.count.series": "{count} séries",
  "account.updateChannels": "Mettre à jour les chaînes",
  "account.loadChannels": "Charger les chaînes",
  "account.subscribe": "S'abonner",
  "account.renew": "Renouveler",
  "account.subscribeMessage": "Bonjour, je souhaite m'abonner à IPTViva.",
  "account.renewMessage": "Bonjour, je souhaite renouveler mon abonnement IPTViva.",
  "account.helpMessage": "Bonjour, j'ai besoin d'aide avec IPTViva.",
  "account.help": "Aide",
  "account.helpText": "Une question, un nouvel appareil, ou une chaîne qui ne marche pas ? Contactez-nous, nous répondons tous les jours.",
  "account.appLanguage": "Langue de l'application",
  "account.channelLanguages": "Langues des chaînes",
  "account.international": "international",
  "account.saveLanguages": "Enregistrer et recharger ma liste",
  "account.languagesSaved": "Enregistré. Votre liste de chaînes se recharge avec ces langues.",
  "account.changeLanguages": "Changer les langues",
  "time.minutes": "{count} min",
  "time.hoursMinutes": "{hours} h {minutes} min",
  "time.days": "{count} jours",
  "time.hour": "{count} heure",
  "time.hours": "{count} heures",
  "home.loading": "Chargement des matchs du jour…",
  "home.failed": "Les matchs du jour n'ont pas pu être chargés. Cette page réessaie chaque minute.",
  "home.welcome": "Bienvenue",
  "home.noMatches": "Pas de grand match de football pour le moment. Ils apparaissent ici dès que nous trouvons des chaînes qui les diffusent et fonctionnent bien.",
  "home.liveNow": "En direct",
  "home.laterToday": "Plus tard aujourd'hui",
  "home.otherLeagues": "Autres",
  "home.favouriteLeague": "Marquer {league} : afficher en premier",
  "home.unfavouriteLeague": "Retirer {league} des favoris",
  "home.browse": "Parcourir",
  "home.allChannels": "Toutes les chaînes",
  "home.anyTime": "À regarder quand vous voulez",
  "home.everyEpisode": "Tous les épisodes",
  "home.todaysMatches": "Les matchs du jour",
  "home.slideOf": "{position} sur {count}",
  "home.previousMatch": "Match précédent",
  "home.nextMatch": "Match suivant",
  "home.football": "Football",
  "home.checking": "Vérification des chaînes…",
  "home.channelIn": "{count} chaîne en {language}",
  "home.channelsIn": "{count} chaînes en {language}",
  "home.moreOther": "{count} de plus dans d'autres langues",
  "home.noChannel": "Pas encore de chaîne",
  "home.atKickoff": "Les chaînes apparaissent au coup d'envoi, une fois vérifiées",
  "home.channelsAtKickoff": "Chaînes au coup d'envoi",
  "home.tomorrow": "Demain",
  "home.days": "Jours",
  "home.comingUp": "À venir",
  "home.seeDay": "Voir {day}",
  "home.channelsOnMatchDay": "Chaînes le jour du match",
  "home.noMatchToday": "Pas de match aujourd'hui, prochain {date}",
  "home.noMatchDay": "Pas de match ce jour, prochain {date}",
  "home.noMatchesDay": "Pas de match des grands championnats ce jour.",
  "home.noSchedule": "Le programme des prochains jours n'est pas encore disponible.",
  "home.watchNow": "Regarder",
  "home.details": "Détails",
  "home.today": "Aujourd'hui",
  "home.inMinutes": "dans {count} min",
  "home.inHours": "dans {count} h",
  "home.oneChannel": "{count} chaîne",
  "home.channels": "{count} chaînes",
  "home.oneLanguage": "{count} langue",
  "home.languages": "{count} langues",
  "home.checkingLong": "Nous vérifions les chaînes qui diffusent ce match. Celles qui fonctionnent apparaissent ici d'ici une minute ou deux.",
  "home.atKickoffLong": "Les chaînes apparaissent ici au coup d'envoi, une fois que nous avons vérifié qu'elles fonctionnent bien.",
  "home.expectedOn": "Prévu sur {name} · pas encore vérifié",
  "home.expectedOnMore": "Prévu sur {name} +{count} · pas encore vérifié",
  "home.willBeOn": "Pas encore vérifiées : ces chaînes seront disponibles dès que nous aurons vérifié qu'elles fonctionnent bien.",
  "home.mightBeOn": "Peut-être sur {name}",
  "home.mightBeOnMore": "Peut-être sur {name} +{count}",
  "home.mightHave": "Pourraient diffuser le match : touchez une chaîne pour l'essayer.",
  "home.mightHaveShort": "Diffuse peut-être le match",
  "home.moreToTry": "D'autres chaînes à essayer",
  "home.notChecked": "Non vérifiée",
  "home.searchMore": "Chercher d'autres",
  "home.searchHint": "Pas dans la liste ? Cherchez les chaînes {channels}.",
  "home.searchHintClubs": "Pas dans la liste ? Cherchez les chaînes des clubs ou le diffuseur du match.",
  "home.commentary": "Langue du commentaire",
  "home.playsSmoothly": "Fonctionne bien",
  "home.mayShowOther": "Peut diffuser un autre match",
  "home.guessesBefore": "Le match est sur l'une des chaînes numérotées, mais nous ne savons pas encore laquelle. Pendant le match, les spectateurs nous aident à la trouver.",
  "home.guessesLive": "Le match est sur l'une des chaînes numérotées, mais nous ne savons pas encore laquelle. Essayez-en une : nous vous demanderons si le match y est.",
  "home.confirmedByViewers": "Confirmé par les spectateurs",
  "player.matchQuestion": "{match} est-il sur cette chaîne ?",
  "player.matchYes": "Oui",
  "player.matchNo": "Non",
  "player.matchThanks": "Merci ! Dès qu'assez de spectateurs sont d'accord, tout le monde voit la réponse.",
  "home.notConfirmed": "Non confirmé : peut-être un match de jeunes",
  "home.watchedNow": "Regardée maintenant · démarre aussitôt",
  "clock.live": "DIRECT",
  "clock.ht": "MT",
  "clock.break": "Pause",
  "clock.penalties": "Tirs au but",
  "clock.ft": "FIN",
  "clock.paused": "Interrompu",
  "player.buffering": "Mise en mémoire…",
  "player.reconnecting": "Reconnexion…",
  "player.paused": "En pause",
  "player.pausedByOtherApp": "Mis en pause par une autre application (un appel ?). Touchez Lecture pour regarder en direct.",
  "player.soundOffByOtherApp": "Le son est coupé pendant qu’une autre application (un appel ?) l’utilise. Touchez pour le rétablir.",
  "player.soundOffShort": "Son coupé (un appel ?) · touchez pour le rétablir",
  "player.finished": "Terminé",
  "player.connecting": "Connexion…",
  "player.queueTitle": "Votre essai gratuit commence dans",
  "player.queueNext": "Vous êtes le prochain.",
  "player.queuePosition": "Vous êtes numéro {position} dans la file.",
  "player.queueBody": "Toutes les places d'essai sont occupées pour le moment. La lecture démarre toute seule, gardez cet écran ouvert. Votre temps d'essai commence quand vous obtenez une place.",
  "player.anyMoment": "D'un instant à l'autre…",
  "player.uhdTitle": "La 4K et la 8K ne sont pas prises en charge sur cet appareil",
  "player.uhdBody": "Cet appareil ne lit pas la 4K ni la 8K : ce titre n'est donc pas disponible ici, et le catalogue n'en a pas de version HD. Passez sur un autre appareil, par exemple un téléviseur, un ordinateur ou un téléphone plus récent, pour avoir tout le catalogue.",
  "browse.uhdHidden": "Les titres en 4K et 8K sont masqués : cet appareil ne peut pas les lire. Passez sur un autre appareil pour avoir tout le catalogue.",
  "browse.uhdPaused": "Les titres en 4K et 8K sont en pause pour l'instant : vous voyez les versions HD. Les applis TV pour LG et Samsung ont toujours tout le catalogue.",
  "player.uhdPausedTitle": "La 4K et la 8K sont en pause pour l'instant",
  "player.uhdPausedBody": "Les titres en 4K et 8K ne sont pas disponibles ici pour l'instant, et celui-ci n'a pas de version HD. Réessayez plus tard, ou utilisez notre appli TV pour LG ou Samsung pour avoir tout le catalogue.",
  "player.uhdPausedSwitched": "La 4K est en pause pour l'instant : lecture de la version HD.",
  "player.uhdSwitched": "Cet appareil ne lit pas la 4K : lecture de la version HD.",
  "player.renewBody": "Renouvelez-le pour continuer à regarder.",
  "player.trialEndedBody": "Nous espérons qu'il vous a plu. Abonnez-vous pour continuer à regarder.",
  "player.fullOne": "Déjà en lecture sur {count} écran",
  "player.full": "Déjà en lecture sur {count} écrans",
  "player.fullBodyOne": "Votre offre permet un écran à la fois. Arrêtez-le pour regarder ici.",
  "player.fullBody": "Votre offre permet {count} écrans en même temps. Arrêtez-en un pour regarder ici.",
  "player.stopAndWatch": "Arrêter {device} et regarder ici",
  "player.replacedTitle": "Arrêté depuis un autre écran",
  "player.replacedBody": "Votre offre permet un nombre limité d'écrans en même temps, et celui-ci a été arrêté pour qu'un autre appareil puisse regarder. Les offres Premium permettent deux écrans en même temps.",
  "player.watchHere": "Regarder ici",
  "player.muted": "Son coupé",
  "player.volumePercent": "Volume {percent} %",
  "player.behindLive": "{time} de retard sur le direct. Revenir au direct",
  "player.goLive": "Revenir au direct",
  "player.prev": "Préc.",
  "player.next": "Suiv.",
  "player.previous": "Précédent",
  "player.previousChannel": "Chaîne précédente",
  "player.nextChannel": "Chaîne suivante",
  "player.previousEpisode": "Épisode précédent",
  "player.nextEpisode": "Épisode suivant",
  "player.back10": "Reculer de 10 secondes",
  "player.forward10": "Avancer de 10 secondes",
  "player.play": "Lecture",
  "player.pause": "Pause",
  "player.audio": "Audio",
  "player.subtitles": "Sous-titres",
  "player.info": "Infos",
  "player.fullscreen": "Plein écran",
  "player.off": "Désactivés",
  "player.quality": "Qualité",
  "player.qualityStandard": "Standard",
  "player.qualityUnplayable": "{quality} n'est pas lisible sur cet appareil ; retour à la qualité précédente.",
  "player.seek": "Position",
  "player.mute": "Couper le son",
  "player.unmute": "Rétablir le son",
  "player.volume": "Volume",
  "player.upNext": "À suivre : {name}",
  "player.playNext": "Épisode suivant",
  "player.watchAgain": "Revoir",
  "playback.network": "Le flux est injoignable. Vérifiez votre connexion ou réessayez plus tard.",
  "playback.stalled": "Le flux a cessé d'envoyer de la vidéo.",
  "playback.no-start": "Le flux n'a pas démarré. Le serveur est peut-être hors service ou trop lent.",
  "playback.forbidden": "Le fournisseur a refusé ce flux. Le compte a peut-être atteint sa limite de connexions.",
  "playback.not-found": "Cette chaîne n'est plus disponible chez le fournisseur.",
  "playback.unsupported": "Le format de ce flux n'est pas pris en charge sur cet appareil.",
  "playback.media": "La vidéo n'a pas pu être décodée.",
  "stats.title": "Statistiques de lecture",
  "stats.engine": "Moteur",
  "stats.resolution": "Résolution",
  "stats.buffered": "Mémoire tampon",
  "stats.stalls": "Blocages",
  "stats.dropped": "Images perdues",
  "stats.reconnects": "Reconnexions",
  "stats.sound": "Son",
  "stats.converted": "converti en AAC",
  "stats.convertedFrom": "converti en AAC depuis {codec}",
  "stats.original": "d'origine",
  "stats.started": "Démarré en",
  "stats.problems": "Derniers problèmes",
  "stats.none": "aucun",
};
